import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsOpsService {
  constructor(private http: HttpClient) {}

  getAppKeys(baseUrl: string, clientKey: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/getAppKey?clientKey=${encodeURIComponent(String(clientKey ?? ''))}`, { withCredentials: true });
  }

  getConfigSettings(baseUrl: string, appKey: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/secureConfigSettings?appKey=${encodeURIComponent(String(appKey ?? ''))}`, { withCredentials: true });
  }

  loadAppSettings(baseUrl: string, clientKey: string, clientDatasource: string, appKey: string): Observable<any> {
    const url = `${baseUrl}/appConfigSettings?clientKey=${encodeURIComponent(String(clientKey ?? ''))}&clientDatasource=${encodeURIComponent(clientDatasource || '')}&appKey=${encodeURIComponent(String(appKey ?? ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  loadClientSettings(baseUrl: string, clientKey: string, clientDatasource: string): Observable<any> {
    const url = `${baseUrl}/clientConfigSettings?clientKey=${encodeURIComponent(String(clientKey ?? ''))}&clientDatasource=${encodeURIComponent(clientDatasource || '')}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  resetCache(adminApiUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('appKey', String(payload?.appKey ?? ''));
    fd.append('clientKey', String(payload?.clientKey ?? ''));
    fd.append('clientDatasource', payload?.clientDatasource || '');
    fd.append('config', payload?.config || '');
    return this.http.post<any>(`${adminApiUrl}/resetCache`, fd, { withCredentials: true });
  }

  getUserDetails(baseUrl: string, userName: string): Observable<any> {
    const fd = new FormData();
    fd.append('userName', userName || '');
    return this.http.post<any>(`${baseUrl}/userDetails`, fd, { withCredentials: true });
  }

  changeSso(adminApiUrl: string, ssoId: string): Observable<any> {
    return this.http.get<any>(`${adminApiUrl}/changeSSO/${encodeURIComponent(ssoId)}`, { withCredentials: true });
  }

  saveSystemSetting(baseUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('key', payload?.key || '');
    fd.append('value', payload?.value || '');
    return this.http.post<any>(`${baseUrl}/saveSystemSetting`, fd, { withCredentials: true });
  }

  saveAppSetting(baseUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('key', payload?.key || '');
    fd.append('value', payload?.value || '');
    fd.append('clientKey ', String(payload?.clientKey ?? ''));
    fd.append('appKey ', String(payload?.appKey ?? ''));
    fd.append('clientDatasource', payload?.clientDatasource || '');
    return this.http.post<any>(`${baseUrl}/saveAppConfigSetting`, fd, { withCredentials: true });
  }

  saveClientSetting(baseUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('key', payload?.key || '');
    fd.append('value', payload?.value || '');
    fd.append('clientKey ', String(payload?.clientKey ?? ''));
    fd.append('clientDatasource', payload?.clientDatasource || '');
    return this.http.post<any>(`${baseUrl}/saveClientSystemSetting`, fd, { withCredentials: true });
  }

  deleteSystemSetting(baseUrl: string, key: string): Observable<any> {
    const fd = new FormData();
    fd.append('key', key || '');
    return this.http.post<any>(`${baseUrl}/deleteSystemSetting`, fd, { withCredentials: true });
  }

  deleteAppSetting(baseUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('key', payload?.key || '');
    fd.append('clientKey', String(payload?.clientKey ?? ''));
    fd.append('appKey ', String(payload?.appKey ?? ''));
    fd.append('clientDatasource', payload?.clientDatasource || '');
    return this.http.post<any>(`${baseUrl}/deleteAppConfigSetting`, fd, { withCredentials: true });
  }

  deleteClientSetting(baseUrl: string, payload: any): Observable<any> {
    const fd = new FormData();
    fd.append('key', payload?.key || '');
    fd.append('clientKey', String(payload?.clientKey ?? ''));
    fd.append('clientDatasource', payload?.clientDatasource || '');
    return this.http.post<any>(`${baseUrl}/deleteClientSystemSetting`, fd, { withCredentials: true });
  }
}
